import React, { useState } from "react";
import { buildWhatsAppInquiryMessage, buildWhatsAppInquiryUrl, companyInfo } from '../data/companyInfo';

const Cta = () => {
  const [newsletterEmail, setNewsletterEmail] = useState('');

  const handleSubmit = (event) => {
    event.preventDefault();

    const inquiryMessage = buildWhatsAppInquiryMessage({
      intro: `Assalam o Alaikum, I want updates from ${companyInfo.name}.`,
      fields: [
        ['Email', newsletterEmail]
      ],
      source: 'Services CTA Newsletter'
    });

    window.open(buildWhatsAppInquiryUrl(inquiryMessage), '_blank', 'noopener,noreferrer');
    setNewsletterEmail('');
  };

  return (
    <section
      className="cta-area"
      data-overlay="title"
      data-opacity={8}
      style={{ backgroundImage: "url(assets/img/bg/cta_bg_1.png)" }}
    >
      <div className="container">
        <div className="row justify-content-center align-items-center">
          <div className="col-lg-5 px-xl-4 text-center">
            <div className="title-area mb-30 mt-n3">
              <h2 className="sec-title text-white text-capitalize">
                Get Updated with the Latest News
              </h2>
            </div>
            <form className="newsletter-form style3" onSubmit={handleSubmit}>
              <input
                className="form-control"
                type="email"
                placeholder="Enter Email"
                value={newsletterEmail}
                onChange={(event) => setNewsletterEmail(event.target.value)}
                required
              />
              <button type="submit" className="th-btn style1 btn-fw">
                Subscribe Now
                <img src="assets/img/icon/plane2.svg" alt="Subscribe" className="ms-2" />
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Cta;
